import request from '../../library/request';
import {MESSAGE_TYPES} from '../../pages/branding/menu/brandingConfig';
import store from '../../store';
import setGlobalState from '../setGlobalState';
import {getState} from '../store.type';
import {uploadFile} from '../user/userActions';

const getEid = () => store.getState().event.eid;

export const updateDesignEmail = async (messageType, data) => {
    const eid = getEid();
    if(data.imageMain?.image){data.imageMain.image = await uploadFile(data.imageMain.image, '', 'designEmail', eid);}
    const lang=store.getState().branding?.currentLang || store.getState().event.lang || 'he';
    const res = await request('branding.updateDesignEmail', 'put', `/event/${eid}/designEmail`, {messageType,data,lang});
    setGlobalState(`branding.data.${lang}.${messageType}`, {...store.getState().branding.data[lang]?.[messageType],...res});
    setGlobalState('branding.previewKey',store.getState().branding.previewKey+1);
};

export const getEmailData = async () => {
    const lang=store.getState().branding?.currentLang || store.getState().event.lang || 'he';
    const res = await request(`branding.getBrandingData.${lang}`, 'get', `/event/${getEid()}/branding`,{lang});
    const branding =store.getState().branding;
    setGlobalState('branding', {...branding, ...res.data, data: {...branding.data, [lang]: res.commonData}});
};
export const getEmailPreview = async (emailContent, messageType) => {
    const lang=store.getState().branding.currentLang;
    const res = await request('branding.getEmailPreview', 'get', `/event/${getEid()}/brandingPreview`,{lang,emailContent,messageType});
    return res.html;
};

export const updateEmailStatus = async (field, value, messageType) => {
    const lang=store.getState().branding?.currentLang || store.getState().event.lang || 'he';
    const res = await request('branding.updateEmailStatus', 'put', `/event/${getEid()}/designEmailStatus`, {lang,field,value,messageType});
    if(messageType === MESSAGE_TYPES.desperate) {
        setGlobalState(`branding.data.${lang}.${messageType}`, {...store.getState().branding.data[lang]?.[messageType],...res});
    }
    if(field==='enabledWhatsapp'){
        const currentMessageTypeData = store.getState().branding.data[lang]?.[messageType] || {};
        setGlobalState(`branding.data.${lang}.${messageType}`, {...currentMessageTypeData, ...res});
    }
    else {
        setGlobalState(`branding.data.${lang}`, {...store.getState().branding.data[lang],...res});
    }
};

export const getSuspendedOrders = async () => {
    const filter = store.getState().branding?.queryFilter || {};
    const freeFilter = store.getState().branding?.freeFilter || '';
    const res = await request('branding.getSuspendedOrders', 'get', `/event/${getEid()}/suspendedOrders`, {filter, freeFilter});
    setGlobalState('branding.suspendedOrders', res.suspendedOrders);
};

export const sendConfirmations = async (data) => {
    const eid = getEid();
    const filter = store.getState().branding?.queryFilter || {};
    const freeFilter = store.getState().branding?.freeFilter || '';
    await request('branding.sendConfirmations', 'post', `/event/${eid}/sendConfirmations`, {filter, freeFilter, ...data});
};

export const saveWhatsAppImage = async (imageData, messageType) => {
    const eid = getEid();
    const lang= getState().branding?.currentLang || 'he';

    if(imageData?.image){imageData.image = await uploadFile(imageData.image, 'image/png', 'whatsappImage', eid);}
    const res = await request('branding.saveWhatsAppImage', 'put', `/event/${eid}/whatsappMessage`, {imageData, lang});
    if(res?.image){
        const messageData = {...getState().branding.data[lang]?.[messageType], whatsappImage: res.image};
        setGlobalState('branding', {...getState().branding, ...res.data, data: {...getState().branding.data, [lang]: {...getState().branding.data[lang], [messageType]: messageData}}});
    }
};

export const updateWhatsAppMessage = async (message, messageType) => {
    const eid = getEid();
    const lang= getState().branding?.currentLang || 'he';
    const res = await request('branding.updateWhatsAppMessage', 'put', `/event/${eid}/whatsappMessage`, {message, lang, messageType});
    const branding = getState().branding;
    const messageData = {...branding.data[lang]?.[messageType], whatsappMessage: res.message};
    setGlobalState('branding', {...branding, ...res.data, data: {...branding.data, [lang]: {...branding.data[lang], [messageType]: messageData}}});
};

export const sendWhatsAppTemplateTrial = async (data) => {
    const eid = getEid();
    const res = await request('branding.sendWhatsAppTemplateTrial', 'post', `/event/${eid}/whatsappTicketTrial`, {...data});
    return res;
};
